<template>
    <div>
        <v-dialog
            v-model="display"
            scrollable
            persistent
            :width="externalWorkshops.length ? '750' : '500'">
            <v-card>
                <v-card-title>
                    {{ $t('external_maintenance_Search') }}
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="search"
                        ref="searchField" 
                        @keypress.enter="searchItem"
                        :error="error.searchField.state"
                        :error-messages="error.searchField.message"
                        :loading="loading.externalMaintenance"
                        :label="$t('search')">
                    </v-text-field>
                     <v-data-table
                        v-if="externalWorkshops.length"
                        dense
                        hide-default-footer
                        :items="externalWorkshops"
                        disable-pagination
                        :height="externalWorkshops.length ? '300' : '100'"
                        v-model="selected.externalMaintenance"
                        :headers="headers.externalMaintenance"
                        show-select
                        single-select>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-if="externalWorkshops.length" :disabled="!selected.externalMaintenance.length" @click="submit({target: 'submit'})" text>
                        {{ $t('btn_select') }}
                    </v-btn>
                    <v-btn @click="close" text>
                        {{ $t('BTN_CLOSE') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="authorizations.external_workshops.create" @click="openExternalWorkshopDialog({editMode: false})" text>
                        <v-icon>mdi-database-plus</v-icon>
                        {{ $t("EXT_WORKSHOP_NEW_TITLE") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <ExternalWorkshopDialog 
            ref="externalWorkshopDialog"
            @record="createAndSubmitNewExternalWorkshop"/>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import ExternalWorkshopDialog from '@/components/ExternalWorkshopDialog';
export default {
    name: "ExternalMaintenanceSearchDialog",
    components: {
        ExternalWorkshopDialog
    },
    data() {
        return {
            display: false,
            search: null,
            loading: {
                data: false,
                externalMaintenance: false,
            },
            selected: {
               externalMaintenance: [] 
            },
            headers: {
                externalMaintenance: [
                    { text: this.$t('EXT_WORKSHOP_NAME'), value: 'name' },
                    { text: this.$t('EXT_WORKSHOP_PHONE'), value: 'phone' },
                    { text: this.$t('EXT_WORKSHOP_ADDRESS'), value: 'address' }
                ]
            },
            error: {
                searchField: {
                    state: false,
                    message: null
                }
            }, 
        }
    },
    computed: {
        ...mapState("externalWorkshop", ["externalWorkshops"]),
        ...mapState("authentication", ["authorizations"]),
    },
    methods: {
        ...mapActions("externalWorkshop", ["fetchExternalWorkshops", "restExternalWorkshops"]),
        open(params) {
            this.search = params;
            this.restExternalWorkshops();
            this.display = true;
            this.searchItem();
        },
         setError(message){
            this.error.searchField.state = true;
            this.error.searchField.message = message;
        },
        clearError(){
            this.error.searchField.state = false;
            this.error.searchField.message = null;
        },
        openExternalWorkshopDialog(params) {
            this.$refs.externalWorkshopDialog.open(params);
        },
        createAndSubmitNewExternalWorkshop(params){
           this.submit({target: 'CreateAndSubmit', data: params})
        },
        async searchItem() {
           
            if(this.search) {
                this.restExternalWorkshops();
                this.clearError();
                this.loading.externalMaintenance = true;
                try {
                    await this.fetchExternalWorkshops({ search: this.search });
                    this.loading.externalMaintenance = false;
                    if(!this.externalWorkshops.length) this.setError(this.$t('no_result'));
                    if(this.externalWorkshops.length == 1) this.submit({ target: 'submit'});
                } catch(error) {
                    this.loading.externalMaintenance = false;
                    let message = error.response ? error.response.data.message : error; 
                    this.setError(message);
                }

            } else {
                this.setError(this.$t('rules_required'))
            }
       },

       submit(params) {
           if(params.target == 'CreateAndSubmit') {
                  this.$emit('submit', params.data);
           } else if(params.target == 'submit') {
               if(this.externalWorkshops.length == 1) this.$emit('submit', this.externalWorkshops[0]);
               else this.$emit('submit', this.selected.externalMaintenance[0]);
           }
            this.close();
       },
        close() {
            this.display = false;
            this.search = null;
            this.selected.externalMaintenance = [];
            this.restExternalWorkshops();
        }
    }
}
</script>